import axiosInstance from '../apiService';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = 'ConnectionType/';

const getConnectionTypes = async (licensorId) => axiosInstance.get(`${ENDPOINTORIGIN}GetConnectionTypes?licensorId=${licensorId}`, constants.REQUIRE_INTERCEPTORS);

const getConnectionTypeById = async (connectionTypeId) => axiosInstance.get(`${ENDPOINTORIGIN}GetConnectionTypeById?connectionTypeId=${connectionTypeId}`, constants.REQUIRE_INTERCEPTORS);

const createConnectionType = async (connectionType) => axiosInstance.post(`${ENDPOINTORIGIN}CreateConnectionType`, connectionType, constants.REQUIRE_INTERCEPTORS);

const updateConnectionType = async (model) => axiosInstance.put(`${ENDPOINTORIGIN}UpdateConnectionType`, model, constants.REQUIRE_INTERCEPTORS);

const deleteConnectionType = async (id) => axiosInstance.delete(`${ENDPOINTORIGIN}DeleteConnectionType?id=${id}`, constants.REQUIRE_INTERCEPTORS);

export {
  getConnectionTypes,
  getConnectionTypeById,
  createConnectionType,
  updateConnectionType,
  deleteConnectionType,
};